// extracted by mini-css-extract-plugin
export default {"wrap":"index_wrap_Ktzw9","content":"index_content_dgui7","list":"index_list_kasO0"};